import { apiServiceConstants } from "../../../constants/apiService.constants";
import { apiService } from "../../../services/apiService";
import { utilService } from "../../../services/utilService";
import { CapabilityTokenModel, CapabilityTokenReq } from "./Call.model";

const getCapabilityTokenInformation = async (
  params: CapabilityTokenReq
): Promise<CapabilityTokenModel> => {
  const respApiResult = await apiService
    .apiCall(
      `get_token/?reg_code=${utilService.getNetwork()}`,
      {...params,type:"1"},
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const capabilityTokenResp = res as CapabilityTokenModel;
      const result: CapabilityTokenModel = {
        isSuccess: true,
        result: capabilityTokenResp.result,
        status: capabilityTokenResp.status,
        message: capabilityTokenResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: CapabilityTokenModel = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const getCapabilityTokenForIncomingCall = async (
  params: CapabilityTokenReq
): Promise<CapabilityTokenModel> => {
  const respApiResult = await apiService
    .apiCall(
      `get_token/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const capabilityTokenResp = res as CapabilityTokenModel;
      const result: CapabilityTokenModel = {
        isSuccess: true,
        result: capabilityTokenResp.result,
        status: capabilityTokenResp.status,
        message: capabilityTokenResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: CapabilityTokenModel = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const createCallHistory = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `user/call-initiate/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });

  return respApiResult;
};

const missedCallStatusUpdate = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `notification/missed-call/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });

  return respApiResult;
};

const handleErrorResponse = () => {};

export const CallService = {
  handleErrorResponse,
  getCapabilityTokenInformation,
  getCapabilityTokenForIncomingCall,
  createCallHistory,
  missedCallStatusUpdate,
};
